import React from "react";

export default function ThemeChanger(props){
    const gray ={
        margin:"0 10px",
        cursor :"pointer",
        color : ""+props.grayColor
      }
    const blue ={
        // color: "hsl(6, 63%, 50%)",
        color : ""+props.blueColor,
        cursor :"pointer"
      }
    const themeChanger ={
        fontSize: "13px",
        color: ""+props.themesColor
      }
      const violet = {
          cursor :"pointer",
          color: ""+props.violetColor
      }

    return(
        <span id = "theme-changer" style = {themeChanger}>
            THEMES:
            <span id = "theme-names">
                <span id = "blue-background" style = {blue} onClick = {props.blue}>Blue</span>
                <span id = "gray-background" style = {gray} onClick = {props.gray}>Gray</span>
                <span id = "violet-background" style = {violet} onClick = {props.violet}>Violet</span>
            </span>
        </span>
    )
}